"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var reset_password_controller_1 = __importDefault(require("./reset-password.controller"));
var reset_password_html_1 = __importDefault(require("./reset-password.html"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.resetpassword", {
        url: "/reset-password/:token",
        controller: reset_password_controller_1.default,
        controllerAs: "vm",
        template: reset_password_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("resetpassword", [])
    .config(config)
    .controller("ResetPasswordController", reset_password_controller_1.default);
